<script setup>
import Institutelayout from './institutelayout.vue';

</script>

<template>
    <Institutelayout></Institutelayout>
</template>